var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dd" }, [
    _vm.loading
      ? _c("p", [_vm._v("Loading...")])
      : _c(
          "ol",
          { class: ["dd-list", "level" + (_vm.level || 0)] },
          [
            !_vm.parentId
              ? _c("li", { staticClass: "dd-item" }, [
                  _c(
                    "div",
                    {
                      staticClass: "dd-handle",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.topLevel }
                    },
                    [_vm._v("Top level")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.items, function(item) {
              return [
                _c(
                  "li",
                  { key: item.id, staticClass: "dd-item " },
                  [
                    _vm.getChildren(item.id).length > 0
                      ? [
                          _c(
                            "button",
                            {
                              staticClass: "minus",
                              style: _vm.getListState(item.id)
                                ? ""
                                : "display: none;",
                              attrs: {
                                type: "button",
                                "data-action": "collapse"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.closeList(item.id)
                                }
                              }
                            },
                            [_vm._v("Collapse")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "add",
                              style: !_vm.getListState(item.id)
                                ? ""
                                : "display: none;",
                              attrs: {
                                type: "button",
                                "data-action": "expand"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.openList(item.id)
                                }
                              }
                            },
                            [_vm._v("Expand")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "dd-handle",
                              staticStyle: { cursor: "pointer" },
                              attrs: { "data-toggle": "collapse" },
                              on: {
                                click: function($event) {
                                  return _vm.selectItem(item)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.name))]
                          )
                        ]
                      : _c(
                          "div",
                          {
                            staticClass: "dd-handle collapse",
                            staticStyle: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.selectItem(item)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.name))]
                        )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.getListState(item.id)
                  ? [
                      _vm.getChildren(item.id).length > 0
                        ? _c("nested-list-component", {
                            key: (_vm.level || 0) + "_" + item.id,
                            attrs: {
                              data: _vm.localData,
                              parentId: item.id,
                              changeQuery: _vm.changeQuery,
                              type: _vm.type,
                              endpoint: _vm.endpoint,
                              level: (_vm.level || 0) + 1
                            },
                            on: {
                              mount: _vm.increaseChildren,
                              destroy: _vm.decreaseChildren
                            }
                          })
                        : _vm._e()
                    ]
                  : _vm._e()
              ]
            }),
            _vm._v(" "),
            !_vm.children
              ? _c("li", { staticClass: "dd-item btn-add" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-sm btn-success btn-rounded",
                      attrs: { href: _vm.shortcutLink }
                    },
                    [_vm._v("Add child")]
                  )
                ])
              : _vm._e()
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-683dd350", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683dd350","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/NestedListComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-683dd350","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/table-elements/NestedListComponent.vue
// module chunks = 0